/* globals $ */
import { easing } from './_vars.js';

export default class ITNotification {
	constructor() {
		this.messageTimeout = null;
		this.timerLength = 5000;
		this.animSpeed = 400;
		this.easing = 'easeInOutQuad';
		this.appendElement  = 'body';
	}
	notificationTimer(element) {
		element.fadeTo(this.animSpeed, 0, this.easing, function(){
			$(this).remove();
		});
	}
	showMessage({ message, messageId, type = 'successful', useTimeout = true }) {
		this.clearTimer();
		// $('.notification').remove();
		$(`<p class="notification notification-${type}" id="${messageId}">${message}<span class="notification-close icon">Close</span></p>`)
		.hide().appendTo(this.appendElement).fadeTo(this.animSpeed, 1, easing);
		if (useTimeout) {
			this.messageTimeout = window.setTimeout(function(){
				this.notificationTimer($('.notification'));
			}.bind(this), this.timerLength);
		}
	}
	hideMessage(messageId) {
		if (messageId) {
			$(`#${messageId}`).remove();
		} else {
			this.clearTimer();
			$('.notification').remove();
		}
	}
	clearTimer() {
		window.clearTimeout(this.messageTimeout)
	}
}
